import { withSingleHitMove } from './moveDecorator.js';

/**
 * Power by HP% (all other generations): 20 @ ≥68.8%, 40 @ 35.4–68.8%, 80 @ 20.8–35.4%, 100 @ 10.4–20.8%, 150 @ 4.2–10.4%, 200 @ <4.2%.
 * @param {import('../../entities/Pokemon.js').default} attacker
 * @returns {number}
 */
function getFlailPower(attacker) {
    if (attacker.stats.maxHp <= 0) return 20;
    const hpPercent = (100 * attacker.stats.hp) / attacker.stats.maxHp;
    if (hpPercent < 4.2) return 200;
    if (hpPercent < 10.4) return 150;
    if (hpPercent < 20.8) return 100;
    if (hpPercent < 35.4) return 80;
    if (hpPercent < 68.8) return 40;
    return 20;
}

/**
 * Custom implementation for Flail.
 * Power is determined by the user's current HP% at the time the move executes (when calculateDamageDealt runs),
 * not when the move is selected. So if the Flail user is hit first and loses HP, Flail uses the reduced HP for power.
 */
export default class Flail {
    /** Used by BattleStateMachine.calculateDamageDealt to get variable power from attacker HP%. */
    static getEffectivePower(_move, attacker) {
        return getFlailPower(attacker);
    }

    static customMoveLogic() {
        // No extra effects; power is handled via getEffectivePower in calculateDamageDealt
    }

    static setUpBattleActions = withSingleHitMove(Flail.customMoveLogic);
}
